import * as React from "react";
import { SVGProps } from "react";
const SvgStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    {...props}
  >
    <path d="M192-696v-72h576v72H192Zm0 528v-216h-48v-72l48-192h576l48 192v72h-48v216h-72v-216H528v216H192Zm72-72h192v-144H264v144Zm-46-216h524-524Zm0 0h524l-30-120H248l-30 120Z" />
  </svg>
);
export default SvgStore;
